import React from "react";
import { Grid, useTheme } from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import EmptyData from "Components/EmptyData/EmptyData";
import * as Icons from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import getFileTypeIcon from "Helpers/fileTypeIcon";

export default function TicketingMessage({ side, data, onClick, noScroll }) {
  const { t } = useTranslation();
  const { direction } = useTheme();
  return (
    <>
      {data && (
        <Grid
          container
          id={"ticket-details"}
          className={`ticket-details ${!noScroll ? "overflow-auto" : "no-scroll"}`}
        >
          {data?.Processes?.length !== 0 ? (
            data?.Processes?.map((item, index) => {
              return (
                <Grid
                  container
                  className={`my-2 ${
                    side === "user"
                      ? item.IsRequest
                        ? "right"
                        : "left"
                      : item.IsRequest
                      ? "left"
                      : "right"
                  }-ticket`}
                >
                  <div className="ticket-body">
                    <div className="ticket-content">
                      <p
                        className="m-0 p-0"
                        style={{ "white-space": "pre-line" }}
                      >
                        {item.Descript}
                      </p>
                      {item.File && (
                        <div className="border-top  w-100 pt-1 mt-1">
                          {`${t('fileAttachment')} :`}
                          <MuiButton
                            onClick={() => onClick(item.File)}
                            innerIcon={getFileTypeIcon(item.File.FileName)}
                            title={item.File.FileName}
                            className="link"
                          />
                        </div>
                      )}
                    </div>
                    <div className="ticket-detail">
                      <small>
                        {item.User} - {item.DateRegister}
                      </small>
                    </div>
                  </div>
                </Grid>
              );
            })
          ) : (
            <EmptyData />
          )}
        </Grid>
      )}
    </>
  );
}
